<template>
  <b-col
    class="col-lg-4 col-xl-4"
    v-if="content !== null"
  >
    <screenshot-modal
      :name="name"
      :content="content"
      :show-controls="showControls"
      @nextScreenshot="nextScreenshot"
      @prevScreenshot="prevScreenshot"
    />
    <div
      class="card pt-5 pb-6 screenshot-wrapper"
      @mouseover="screenshotHover = true"
      @mouseleave="screenshotHover = false"
    >
      <b-button
        v-if="screenshotHover"
        size="md"
        variant="primary"
        @click="openModal"
        class="zoom-btn"
      >
        Zoom
      </b-button>
      <img
        :src="content"
        class="screenshot-image"
      >

      <b-button
        v-if="deleteAllowed && screenshotHover"
        size="md"
        variant="danger"
        data-test="image-delete-button"
        class="bin-btn"
        :class="{'btn-loading': isDeleteInProgress}"
        @click="deleteScreenshot"
      >
        <i class="fa fa-trash-can" />
      </b-button>
    </div>
  </b-col>
</template>
<script>
import { mapActions } from 'vuex';
import * as reportingTypes from '@/modules/reporting/store/types';
import ScreenshotModal from '@/modules/reporting/components/ScreenshotModal.vue';

export default {
  name: 'Screenshot',
  components: { ScreenshotModal },
  props: {
    name: {
      type: String,
      default: '',
    },
    deleteAllowed: {
      type: Boolean,
      default: false,
    },
    showControls: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDeleteInProgress: false,
      screenshotHover: false,
      content: null,
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('reporting', [
      reportingTypes.FETCH_CAMPAIGN_SCREENSHOT_IMAGE,
      reportingTypes.DELETE_CAMPAIGN_SCREENSHOT,
    ]),
    nextScreenshot(imageName) {
      this.$emit('nextScreenshot', imageName);
    },
    prevScreenshot(imageName) {
      this.$emit('prevScreenshot', imageName);
    },
    openModal() {
      this.$root.$emit('bv::show::modal', `screenshotModal-${this.name}`);
      this.$emit('updateCurrentScreenshot', this.name);
    },
    closeModal() {
      this.$root.$emit('bv::hide::modal', `screenshotModal-${this.name}`);
      this.$emit('updateCurrentScreenshot', '');
    },
    async deleteScreenshot() {
      if (!this.isDeleteInProgress) {
        this.isDeleteInProgress = true;
        try {
          await this.DELETE_CAMPAIGN_SCREENSHOT(this.name);
          this.content = null;
          this.$emit('deleteScreenshot');
        } finally {
          this.isDeleteInProgress = false;
        }
      }
    },
  },
  async created() {
    const imageContent = await this.FETCH_CAMPAIGN_SCREENSHOT_IMAGE(this.name);
    this.content = `data:image/jpeg;base64,${imageContent}`;
  },
};
</script>
<style lang="scss" scoped>
.screenshot-wrapper {
  height: 330px;
  padding: 24px 12px;
  justify-content: center;
}
.screenshot-image {
  width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
}
.zoom-btn {
  position: absolute;
  z-index: 1000;
  top: 10%;
  left: 50%;
  transform: translate(-50%);
  width: 70px;
}
.bin-btn {
  position: absolute;
  text-align: center;
  z-index: 1000;
  bottom: 5%;
  left: 50%;
  transform: translate(-50%);
}
</style>
